module.exports = __webpack_public_path__ + "static/media/send.c70b9721.svg";